import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class ManageCategoryService {
	public static manageCategoryGetAll(input: any) {
		return Http.axios()
			.post(`/api/Categories/GetAllCategories`, input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static manageCategoryStatusUpdate(input: any) {
		return Http.axios()
			.post("/api/Categories/updateCategorieStatus", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static manageCategoryCreate(input: any) {
		return Http.axios()
			.post("/api/Categories/create", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static manageCategoryUpdate(input: any) {
		return Http.axios()
			.post("/api/Categories/update", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static manageCategoryDelete(input: any) {
		return Http.axios()
			.delete(`/api/Categories/delete/${input}`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static manageCategoryGetAllActiveCategories() {
		return Http.axios()
			.get(`/api/Categories/GetAvailableCategories`, {
				headers: { Authorization: getUserAccessToken() },
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}
